var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('v-select',{attrs:{"value":_vm.value,"label":"Timezone","items":_vm.items,"item-text":"name","item-value":"value","disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }